import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react"

import { CircularProgress, Divider } from "@mui/material"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useAxiosWithAuth } from "../../common/api/hooks/useAxiosWithAuth"
import { URL } from "../../common/api/urls"
import useAuth from "../../common/hooks/useAuth"
import usePermissions from "../../common/hooks/usePermissions"
import useSyncUidataNotifyFlags from "../../common/hooks/useSyncUidataNotifyFlags"
import { DEMO_POPUP_STATUS, DEMO_POPUP_TYPES } from "../../common/utility/constant.js"
import {
  BOOKMARK_CATEGORY_AUTOSAVE,
  CONSTANTS,
  INSTRUMENT_POLLING_TIME,
  MP_CHART_RELOAD_TIME,
  TEXT_MSGS,
  TIME_FRAME_VALUES,
  USER_RESOURCES_LIST,
  USER_ROLE_FIELDS,
} from "../../common/utility/constant"
import { breakDSTR, isChartOptionAccessAllowed, transformAndReverseMap, useQuery } from "../../common/utility/helperFunc"
import {
  CHART_TYPE,
  MAX_PROFILE_TO_LOAD,
  VA_TYPE,
  VP_TYPE,
} from "../../common/utility/mp_chart_constants"
import { UserSettingsContext } from "../../setup/routes-manager/RequireAuth"
import BarChart from "./bar_chart"
import LineChartFooter from "./components/LineChartFooter"
import LineChartFooterNew from "./components/LineChartFooterNew"
import ConfirmActionDialog from "./components/confirm_dialog"
import MPChart from "./components/mpchart"
import MPChartFooter from "./components/mpchart_footer"
import MPChartHeaderSettings from "./components/mpchart_header"
import AppErrorPopup from "../../components/AppErrorPopup";
import MPChartRightPanel from "./components/mpchart_right_panel"
import PRICE_TABLE from "./components/price_table"
import LineChart from "./line_chart"
import OrderflowContainer from "./orderflow_container"
import StockChartHV from "./stock_chart_hv"
import ChartContainer from "./chart_container";
import LineChartContainer from "./LineChartContainer"
import BarChartSettings from "./components/barchart_settings"
import LineChartContainerNew from "./LineChartContainerNew"
import OfDemoPopup from "./components/orderflow_demo_popup"
import DemoConfirmationPopup from "./components/of_demo_confirm_popup"

// const DEFAULT_PROFILE_WIDTH=120;
// const DEFAULT_PROFILE_WIDTH_WEEKLY=200;
// const DEFAULT_PROFILE_WIDTH_MONTHLY=200;
// const DEFAULT_PROFILE_WIDTH_YEARLY=400;
const DEFAULT_PROFILE_WIDTH = 60
const DEFAULT_PROFILE_WIDTH_WEEKLY = 100
const DEFAULT_PROFILE_WIDTH_MONTHLY = 120
const DEFAULT_PROFILE_WIDTH_YEARLY = 400
const PROFILE_LOAD_FACTOR = 1.2

const BarChartContainer = (props) => {
  // console.log("props==========================>",props);
  const { auth, setAuth } = useAuth();
  const syncUidataNotifyFlags = useSyncUidataNotifyFlags();
  // ============================================================
  // NEW - Centralized Permission System
  // See: src/common/utility/permissionService.js
  // ============================================================
  const permissions = usePermissions();
  // OLD - Hardcoded PRO role and TBT_FEED resource check (DEPRECATED)
  // Replaced by: permissions.isEliteUser()
  // const isEliteUser = (auth.role.find(el => el == USER_ROLE_FIELDS.PRO) && auth.resources.find(el => el == USER_RESOURCES_LIST.TBT_FEED))
  // NEW - Use centralized permission service
  const isEliteUser = permissions.isEliteUser();
  const location = useLocation();
  const [tabData,setTabData]=useState(props?.tabData??undefined)
  const [initialData,setInitialData]=useState((props?.tabData?.data?.[props.val] &&props?.tabData?.data?.[props.val].type) ?props?.tabData?.data?.[props.val]: undefined)
  const [toggleState,setToggleState]=useState(true);
  // const [chartType, setChartType] = useState(
  //   props.chartType ? props.chartType : CHART_TYPE.BAR_CHART
  // )
  const [chartType, setChartType] = useState(initialData?.type ?? props.chartType ?? CHART_TYPE.BAR_CHART);
  const { userSettings, setUserSettings } = useContext(UserSettingsContext)
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0)
  // const from = location.state?.from?.pathname || "/login";
  const from = "/login"
  const symbol = useQuery("symbol")
  console.log("props.key 1=", props.key, props.val)
  const [state, setState] = useState({
    isLoading: true,
    liveData: undefined,
    chartData: undefined,
    krlData: undefined,
    instrument: props.symbol
      ? props.symbol
      : symbol && props.val == 0
      ? symbol
      : userSettings.data.default_instrument,
    // instrument:symbol&&props.val==0?symbol:userSettings.data.default_instrument,
    isIncrementalData: false,
    lastLoadTime: -1,
    isInstrumentLive: false,
    // OLD - Hardcoded FAST_DATA role check (DEPRECATED)
    // Replaced by: permissions.getChartReloadInterval()
    // reloadInerval: auth.role.find((el) => el == USER_ROLE_FIELDS.FAST_DATA)
    //   ? MP_CHART_RELOAD_TIME.FAST_DATA
    //   : MP_CHART_RELOAD_TIME.SLOW_DATA,
    // NEW - Use centralized permission service
    reloadInerval: permissions.getChartReloadInterval(),
    pollingInterval: MP_CHART_RELOAD_TIME.POLLING_TIME,
    refreshInterval: -1,
    selectedTimeFrame: "daily",
    isPollingAllowed: false,
    isTradingSessionActive: false,
    isJsonLoaded: false,
    isFirtLoadComplete: false,
    apiData: undefined,
    bookmarkData: undefined,
    isStatusCheckAllowed: false,
    statusCheckPollingInterval: MP_CHART_RELOAD_TIME.POLLING_TIME,
    isLivePollingAllowed: false,
    krlPollingTime: MP_CHART_RELOAD_TIME.KRL_POLLING_TIME,
    krlPollingAllowed: false,
    tradeDates: undefined,
    dstrData: undefined,
    chartRendered:false,
  })
  const [
    cancelUiData,
    responseDataUiData,
    errorUiData,
    loadedUiData,
    resetUiData,
    executeAPIUiData,
  ] = useAxiosWithAuth()
  const [selectedInstrumentData, setSelectedInstrumentData] = React.useState()
  const [selectedInstrument, setSelectedInstrument] = React.useState("")
  const [instrumentsData, setInstrumentsData] = useState()
const [instrumentsLoaded, setInstrumentsLoaded] = useState(false);
const [toggleRefresh,setToggleRefresh]=useState(undefined)


  const [footerLoaded, setFooterLoaded] = useState(false)
  // OLD - Hardcoded FAST_DATA role check (DEPRECATED)
  // Replaced by: permissions.isPremiumUser()
  // const [npocAllowed, setNPOCAllowed] = useState(
  //   auth.role.find((el) => el == USER_ROLE_FIELDS.FAST_DATA) ? true : false
  // )
  // NEW - Use centralized permission service
  const [npocAllowed, setNPOCAllowed] = useState(permissions.isPremiumUser())

  const [msgState, setMsgState] = useState({
    open: false,
    msg: "",
    severity: "info",
  })

  const { open, msg, severity } = msgState

  const handleClose = (event, reason) => {
    setMsgState({ ...msgState, open: false })
  }

  const {
    isLoading,
    chartData,
    liveData,
    krlData,
    isIncrementalData,
    isInstrumentLive,
    lastLoadTime,
    reloadInerval,
    pollingInterval,
    instrument,
    refreshInterval,
    selectedTimeFrame,
    isPollingAllowed,
    isTradingSessionActive,
    isJsonLoaded,
    isFirtLoadComplete,
    apiData,
    bookmarkData,
    isStatusCheckAllowed,
    statusCheckPollingInterval,
    isLivePollingAllowed,
    krlPollingTime,
    krlPollingAllowed,
    tradeDates,
    dstrData,
    chartRendered,
  } = state
  const stateRef = useRef(state)

  const [cancel, responseData, error, loaded, reset, executeAPI] =
    useAxiosWithAuth()
  const [
    cancelLive,
    responseDataLive,
    errorLive,
    loadedLive,
    resetLive,
    executeLive,
  ] = useAxiosWithAuth()
  const [
    cancelSaved,
    responseDataSaved,
    errorSaved,
    loadedSaved,
    resetSaved,
    executeAPISaved,
  ] = useAxiosWithAuth()
  const [
    cancelDelete,
    responseDataDelete,
    errorDelete,
    loadedDelete,
    resetDelete,
    executeAPIDelete,
  ] = useAxiosWithAuth()
  const [
    cancelStatus,
    responseDataStatus,
    errorStatus,
    loadedStatus,
    resetStatus,
    executeAPIStatus,
  ] = useAxiosWithAuth()
  const [
    cancelKRL,
    responseDataKRL,
    errorKRL,
    loadedKRL,
    resetKRL,
    executeAPIKRL,
  ] = useAxiosWithAuth()
  const [
    cancelKRLPoll,
    responseDataKRLPoll,
    errorKRLPoll,
    loadedKRLPoll,
    resetKRLPoll,
    executeAPIKRLPoll,
  ] = useAxiosWithAuth()

  const selectedInstrumentRef = useRef(selectedInstrument)
  const [selectedTPO, setSelectedTPO] = useState(2)
  const [selectedInstrumentTPOData, setSelectedInstrumentTPOData] = useState()
  const [globalVolumeVisible, setGlobalVolumeVisible] = useState(
    userSettings.data.show_global_vp
  )
  const [volumeNumberVisible, setVolumeNumberVisible] = useState(
    userSettings.data.show_global_vp_numbers
  )
  const [onlyVolumeProfile, setOnlyVolumeProfile] = useState(false)
  const [tpoOnVolume, setTpoOnVolume] = useState(false)
  const [perProfilelVolumeVisible, setPerProfileVolumeVisible] = useState(false)
  const [perProfileVolumeNumberVisible, setProfileVolumeNumberVisible] =
    useState(false)
  const navigate = useNavigate()
  const [autoCenter, setAutocenter] = useState(false)
  // const [viewState, setViewState] = React.useState({tpo_only:true,vol_tpo_side:false,only_vol:false,tpo_on_vol:false});
  const [viewState, setViewState] = React.useState({
    tpo_only:
      userSettings.data.vp_type == VP_TYPE.NONE ||
      userSettings.data.vp_type == VP_TYPE.BACKGROUND,
    vol_tpo_side: userSettings.data.vp_type == VP_TYPE.ASIDE,
    only_vol: userSettings.data.vp_type == VP_TYPE.ALONE,
    tpo_on_vol: userSettings.data.vp_type == VP_TYPE.BACKGROUND,
  })

  const [tpoBasedVA, setTPOBasedVA] = useState(userSettings.data.va_type)
  const [toggleReset, setToggleReset] = useState(false)
  const [toggleUnselect, setToggleUnselect] = useState(false)
  const [rightPanelConatinerState, setRightPanelConatinerState] = useState({
    show: false,
    metadata: undefined,
    histoticalData: undefined,
    selectedIndexes: [],
    isLiveSession: false,
  })
  const [toggleSave, setToggleSave] = useState(false)
  const [toggleSaveBookmark, setToggleBookmark] = useState(false)
  const [jsonData, setJsonData] = useState()
  const [vpType, setVPType] = React.useState(userSettings.data.vp_type)
  const [stateData, setStateData] = useState(props.stateData)
  const [openAutosaveDeleteDialog, setOpenAutosaveDeleteDialog] =
    useState(false)
  const [reloadInstrument, setReloadInstrument] = useState()
  const [isDirty, setIsDirty] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [toggleMPLoading, setToggleMPLoading] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [tableData, setTableData] = useState(false)
  const [levelData, setLevelData] = useState([-1, -1]);
  const [showSettings,setShowSettings]=useState(false);
  
  // Add volx toggle state
  const [volxLinesToggleEnabled,setVolxLinesToggleEnabled]=useState(() => {
    // Always inherit from LVO setting if available, regardless of chart type
    if (userSettings.data["lvo_visibility_ntm_volx"] !== undefined) {
      const lvoValue = userSettings.data["lvo_visibility_ntm_volx"];
      return lvoValue;
    }
    return false;
  });
  
  const [cancelPoll,responseDataPoll, errorPoll, loadedPoll, resetPoll,executeAPIPoll ] = useAxiosWithAuth();
  const [showDemoState,setShowDemoState]=useState({demoType:undefined});
  const [showDemoPopup,setShowDemoPopup]=useState(false);
  const [showDemoConfirmPopup,setShowDemoConfirmPopup]=useState(false);
  const [demoIndex,setDemoIndex]=useState(undefined);
  

  const openStockChart = () => {
    navigate(
      `/stock-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`,
      { replace: false }
    )
  }

  useEffect(() => {
    // executeAPIKRL(URL.GET_KRL_LIST,"POST",{"symbol":"NIFTY"})
    console.log("props MP container=", props)
    if (props.setChartType) props.setChartType(chartType)
      const timeout = setTimeout(() => {
        setTabData(undefined);
        setInitialData(undefined);
        console.log("Reload props BC container setInitialData=undefined"); 
    }, 1000);
    return () => {
      // just to clear the timeout when component unmounts
      clearTimeout(timeout)
    }
  }, [])

  const openMPChart = () => {
    setShowTable(false)
    if (chartType != CHART_TYPE.MARKET_PROFILE) {
      console.log("live panel resetRightPanel===1")
      props.resetRightPanel()
      // console.log("state=",state);
      setPollingAllowedVal(true)
      setChartType(CHART_TYPE.MARKET_PROFILE)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.MARKET_PROFILE)

      if(props.setIsDirty){
        props.setIsDirty(true);
      }
      // setState((prevState) => ({
      //   ...prevState,
      //   isLoading:false}));

      // setSelectedInstrument(selectedInstrument);
    }
    // navigate(`/stock-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });
  }

  const openLineChart = () => {
    // if (chartType != CHART_TYPE.LINE_CHART) {
      console.log("Future test selected instrument",stateData)
      console.log("live panel resetRightPanel===2")
      props.resetRightPanel()
      setPollingAllowedVal(false);
      setStateData(undefined);
      setToggleState(!toggleState);
      setChartType(CHART_TYPE.LINE_CHART)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.LINE_CHART)
      if(props.setIsDirty){
        props.setIsDirty(true);
      }
    // }
    // navigate(`/line-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });
  }

  const openOFChart = () => {
    setShowTable(false)
    if (chartType != CHART_TYPE.OF_CHART) {
      console.log("live panel resetRightPanel===1")
      props.resetRightPanel()
      // console.log("state=",state);
      setPollingAllowedVal(false)
      setChartType(CHART_TYPE.OF_CHART)
      if (props.setChartType != undefined)
        props.setChartType(CHART_TYPE.OF_CHART)
    }
  }

  useEffect(() => {
    console.log(
      "Chart container Props changes, proUser",
      props.chartStateData,
      props.proUser
    )
  }, [props.chartStateData])


  

  //execute the data fetch on the component mount
  useEffect(() => {
    // if(selectedInstrument!=undefined && isLoading){
   
   
    setIsDirty(true)
    setJsonData(undefined)
    setState((prevState) => ({
      ...prevState,
      isJsonLoaded: true,
      isFirtLoadComplete: true,
    }))
  }, [])

  useEffect(() => {
   
    if (selectedInstrument != undefined) {
      // setJsonData(undefined);
      setState((prevState) => ({
        ...prevState,
        // apiData:undefined,
        bookmarkData: undefined,
        // isJsonLoaded:false,
      }))
      setFooterLoaded(true)
    
      setIsDirty(true)
    }
  }, [selectedInstrument, selectedTimeFrame, toggleMPLoading])

  useState(() => {
    console.log("charttype,state", chartType, state)
  }, [state])
 

 

  const setPollingAllowedVal = (val) => {
    setState((prevState) => ({
      ...prevState,
      isPollingAllowed: val,
    }))
  }

 


  const handleVPType = (val) => {
    setVPType(val)
  }

  const handleFooterLoaded = () => {
    setFooterLoaded(true)
  }

  const handleChartChange = (data) => {
    console.log("handleChartChange", data)
    if (!isChartOptionAccessAllowed(permissions, data)) {
      props.openSubscribeModal()
      return
    }
    setStateData(data)
    setChartType(data.data.chart_type)
    if (props.setChartType) {
      props.setChartType(data.data.chart_type)
    }
    setIsDirty(true);
    if(props.setIsDirty){
      props.setIsDirty(true);
    }
  }

  const barPlotData = stateData?.data ?? { plot: "", doix: false }
  const barPlotType = barPlotData.plot ?? ""

  

  useEffect(() => {
    selectedInstrumentRef.current = selectedInstrument
    console.log(
      "useeffect selectedinstrument",
      selectedInstrument,
      selectedInstrumentRef.current
    )
  }, [selectedInstrument])


 

  const showPriceTable = () => {
    console.log("showTable=", showTable)
    setShowTable(true)
  }

  const showSubscribeModal = (isCustom, msg) => {
    props.openSubscribeModal(isCustom, msg)
  }


  useEffect(() => {
    console.log("Boundary levelData useeffect chart container=", levelData)
    // loadDataLevel();
  }, [levelData])

  const openSunscriptionModal = (isCustom, msg) => {
    props.openSubscribePropModal(isCustom, msg)
  }

  useEffect(() => {
    let data = {
      symbol: "NIFTY",
      // instruments: 1,
      // tpoList: 1,
      additional_instruments: [symbol],
      dateList: 1,
    }
    executeAPIUiData(URL.MPCHART_UIDATA, "POST", data)
  }, [])

  useEffect(() => {

    const timeout = setInterval(() => {
      let data = {
        "symbol": "NIFTY",
      };

      try {
        executeAPIPoll(URL.MPCHART_UIDATA, "POST", data);
      } catch (error) {
        console.error("API Poll error:", error);
      }
    }, INSTRUMENT_POLLING_TIME);

    return () => {
      console.log("Cleanup called");
      clearInterval(timeout);
    };
  }, []);

  /**
   * API response handler
   */
  useEffect(() => {
    if (loadedUiData) {
      if (responseDataUiData != null) {
        if (responseDataUiData.instruments) {
          responseDataUiData.instruments = responseDataUiData.instruments.map((item) =>
          transformAndReverseMap(item)
        );
        responseDataUiData.instruments = responseDataUiData.instruments.filter(
          (e) => e.line_chart === true
        )
        let index = 0
        if (symbol != undefined && symbol != "") {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.instr === symbol
          )
          if (index == -1) index = 0
        } else if (
          userSettings != undefined &&
          userSettings.data != undefined
        ) {
          index = responseDataUiData.instruments.findIndex(
            (item) => item.name === userSettings.data.default_instrument
          )
          if (index == -1) index = 0
        }
        // setOptions(responseDataUiData.instruments)
        setInstrumentsData(responseDataUiData.instruments) // all data
      if(props.stateData==undefined&& props.val==0 && !props.isGlobalBookmark){
        console.log("searchparams test line chart container=",props.stateData)
        setSearchParams({"symbol":responseDataUiData.instruments[index].instr})
      }

        setSelectedInstrument(responseDataUiData.instruments[index].instr) // only name of selected data
        setSelectedInstrumentData(responseDataUiData.instruments[index]) // current selected all data
        setInstrumentsLoaded(true);
      }
        
      if (responseDataUiData.of_demo_status != undefined && responseDataUiData.notify_of_demo) {
        if (responseDataUiData.of_demo_status === DEMO_POPUP_STATUS.DEMO_NOT_STARTED) {
          setShowDemoState({ demoType: DEMO_POPUP_TYPES.NEW_USER });
          setShowDemoPopup(true);
        } else if (responseDataUiData.of_demo_status === DEMO_POPUP_STATUS.DEMO_STARTED) {
          setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_ACTIVE });
          setShowDemoPopup(true);
          setDemoIndex(responseDataUiData.demo_index);
      } else if (responseDataUiData.of_demo_status === DEMO_POPUP_STATUS.DEMO_FINISHED) {
          const hasOfferTr = responseDataUiData.of_demo_offer_tr !== undefined && responseDataUiData.of_demo_offer_tr !== null;
          setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_COMPLETED, hasOfferTr: hasOfferTr });
          setShowDemoPopup(true);
        }
      }
      syncUidataNotifyFlags(responseDataUiData);
    //   setState((prevState) => ({
    // ...prevState,
    // isLoading:false,
    // }));

        // setTradeDates(responseData.tradeDates);
        // props.instrumentChange(
        //   responseData.instruments[index],
        //   responseData.tpo_groups[responseData.instruments[index].tpo_group]
        //     ? responseData.tpo_groups[responseData.instruments[index].tpo_group]
        //     : responseData.tpo_groups["DEFAULT"],
        //   tempTPO,
        //   responseData.tradeDates
        // );
        // setInstrumentLoaded(true);
      } else if (error !== null) {
        console.log("Error data=", error)
        reset()
      }
    }
  }, [loadedUiData, responseDataUiData])

    useEffect(() => {
    if (loadedPoll) {
      if (responseDataPoll != null) {
        if (responseDataPoll.of_demo_status != undefined && responseDataPoll.notify_of_demo) {
          if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_NOT_STARTED) {
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.NEW_USER });
            setShowDemoPopup(true);
          } else if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_STARTED) {
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_ACTIVE });
            setShowDemoPopup(true);
            setDemoIndex(responseDataPoll.demo_index);
          } else if (responseDataPoll.of_demo_status === DEMO_POPUP_STATUS.DEMO_FINISHED) {
            const hasOfferTr = responseDataPoll.of_demo_offer_tr !== undefined && responseDataPoll.of_demo_offer_tr !== null;
            setShowDemoState({ demoType: DEMO_POPUP_TYPES.DEMO_COMPLETED, hasOfferTr: hasOfferTr });
            setShowDemoPopup(true);
          }
        }
        syncUidataNotifyFlags(responseDataPoll);
      } else if (error !== null) {
        console.log("Error data=", error)
        reset()
      }
    }
  }, [loadedPoll, responseDataPoll])

  const instrumentChange = (data) => {
    setSelectedInstrument(data.instr)
    setSelectedInstrumentData(data)
  }

  const setChartRenderedState=(val)=>{
    setState((prevState)=>({
      ...prevState,
      chartRendered:val
    }))
    if(props.setChartLoaded){
      // console.log("HelloTest val 1=",val)
      const timeout = setTimeout(() => {
        props.setChartLoaded(val);
    }, 1000);
      
    }
   }

  useEffect(() => {
    console.log("useEffect is called for props.stateData Line chart container",props.stateData)
 
    // if(instrumentsData && props.stateData){
    //   setInstrumentsLoaded(false);
    //   let index = responseDataUiData.instruments.findIndex((item) => item.instr === props.stateData.symbol)
    //   console.log("useEffect is called for props.stateData Line chart container 1",props.stateData,index)
    //   if(index!=-1){
    //     setSelectedInstrument(responseDataUiData.instruments[index].instr) // only name of selected data
    //     setSelectedInstrumentData(responseDataUiData.instruments[index]) // current selected all data
    //     }
    // }
    setStateData(props.stateData);
    // setInstrumentsLoaded(true);

}, [props.stateData])

  // Ensure selectedInstrumentData is set for BAR_CHART if we have selectedInstrument but no selectedInstrumentData
  useEffect(() => {
    if (chartType == CHART_TYPE.BAR_CHART && !selectedInstrumentData) {
      // Determine which instrument symbol to use
      const instrumentSymbol = selectedInstrument || state.instrument;
      if (!instrumentSymbol) return;
      
      // Try to find in instrumentsData
      let foundInstrument = null;
      if (instrumentsData) {
        foundInstrument = instrumentsData.find((item) => item.instr === instrumentSymbol);
        if (foundInstrument) {
          setSelectedInstrumentData(foundInstrument);
          return;
        }
      }
      
     
      const minimalInstrumentData = {
        instr: instrumentSymbol,
        symbol: instrumentSymbol,
        name: instrumentSymbol,
        line_chart: true,
        of: false,
      };
      setSelectedInstrumentData(minimalInstrumentData);
      if (!selectedInstrument) {
        setSelectedInstrument(instrumentSymbol);
      }
    }
  }, [chartType, selectedInstrument, selectedInstrumentData, instrumentsData, state.instrument])

  useEffect(() => {
    console.log("Watchlist toggle refresh bc containr", props.toggleRefresh, toggleRefresh, toggleState)
    //  if(toggleRefresh!=props.toggleRefresh)
    if (toggleRefresh != undefined) {
      setStateData();
      setToggleState(!toggleState)
    }
    setToggleRefresh(props.toggleRefresh)


  }, [props.toggleRefresh])

const openSettings=()=>{
  setShowSettings(true);
 }

 const cancelSettings=()=>{
  setShowSettings(false);
 }

 const saveSettings=(settings)=>{
  // console.log(" Settings save settings in chart container",settings);
  setUserSettings(settings);
 }

// Add volx toggle function
const changeVolxLinesToggle=(val)=>{
  setVolxLinesToggleEnabled(val);
}

  return (
    <>
      {chartType == CHART_TYPE.MARKET_PROFILE ? (
      
        <ChartContainer
        id={props.id}
        val={props.val}
        boundClass={props.boundClass}
        chartScreenType={props.chartScreenType}
        setChartType={props.setChartType}
        chartStateData={props.chartStateData}
        //symbol={selectedInstrument}
        resetRightPanel={props.resetRightPanel}
        setRightPanel={props.setRightPanel}
        openSubscribeModal={props.openSubscribePropModal}
        basicUser={props.basicUser}
        proUser={props.proUser}
        setChartLoaded={props.setChartLoaded}
        saveChartState={props.saveChartState}
        tabData={tabData}
        isGlobalBookmark={props.isGlobalBookmark}
        globalBookmarkData={props.globalBookmarkData}
        setIsDirty={props.setIsDirty}
        toggleRefresh={toggleRefresh}
      ></ChartContainer>
        )
       : (
        <>
          {chartType == CHART_TYPE.OF_CHART ? (
            <OrderflowContainer
              id={props.id}
              val={props.val}
              boundClass={props.boundClass}
              chartScreenType={props.chartScreenType}
              setChartType={props.setChartType}
              chartStateData={props.chartStateData}
              //symbol={selectedInstrument}
              resetRightPanel={props.resetRightPanel}
              setRightPanel={props.setRightPanel}
              openSubscribeModal={props.openSubscribePropModal}
              basicUser={props.basicUser}
              proUser={props.proUser}
              setChartLoaded={props.setChartLoaded}
              saveChartState={props.saveChartState}
              tabData={tabData}
              isGlobalBookmark={props.isGlobalBookmark}
              globalBookmarkData={props.globalBookmarkData}
              setIsDirty={props.setIsDirty}
              toggleRefresh={toggleRefresh}
            ></OrderflowContainer>
          ) : (
            <></>
          )}
     
           {chartType==CHART_TYPE.LINE_CHART?
    // <LineChart id={props.id} val={props.val} stateData={stateData} symbol={selectedInstrument} nDays={userSettings.data.default_lc_ndays}></LineChart>
    <>
    {isEliteUser?
    <LineChartContainerNew
    key={0}
    val={props.val}
    id={props.id}
    symbol={selectedInstrument}
    nDays={userSettings.data.default_lc_ndays}
    boundClass={props.boundClass}
    setChartType={props.setChartType}
    resetRightPanel={props.resetRightPanel}
    setRightPanel={props.setRightPanel}
    chartScreenType={props.chartScreenType}
    basicUser={props.basicUser}
    openSubscribeModal={props.openSubscribePropModal} 
    // openSubscribePropModal={showSubscribeProModal}
    proUser={props.proUser}
    chartStateData={props.chartStateData}
    stateData={stateData}
    setChartLoaded={props.setChartLoaded}
    saveChartState={props.saveChartState}
    tabData={tabData}
    isGlobalBookmark={props.isGlobalBookmark}
    globalBookmarkData={props.globalBookmarkData}
    setIsDirty={props.setIsDirty}
    toggleRefresh={toggleRefresh}
    volxLinesToggleEnabled={volxLinesToggleEnabled}
    changeVolxLinesToggle={changeVolxLinesToggle}
  />:
    <LineChartContainer
    key={0}
    val={props.val}
    id={props.id}
    symbol={selectedInstrument}
    nDays={userSettings.data.default_lc_ndays}
    boundClass={props.boundClass}
    setChartType={props.setChartType}
    resetRightPanel={props.resetRightPanel}
    setRightPanel={props.setRightPanel}
    chartScreenType={props.chartScreenType}
    basicUser={props.basicUser}
    openSubscribeModal={props.openSubscribePropModal} 
    // openSubscribePropModal={showSubscribeProModal}
    proUser={props.proUser}
    chartStateData={props.chartStateData}
    stateData={stateData}
    setChartLoaded={props.setChartLoaded}
    saveChartState={props.saveChartState}
    tabData={tabData}
    isGlobalBookmark={props.isGlobalBookmark}
    globalBookmarkData={props.globalBookmarkData}
    setIsDirty={props.setIsDirty}
    toggleRefresh={toggleRefresh}
  ></LineChartContainer>
    }
  </>
    :
    <></>}
          {chartType == CHART_TYPE.HV_CHART ? (
            <StockChartHV
              id={props.id}
              stateData={stateData}
              symbol={selectedInstrument}
              nDays={userSettings.data.default_lc_ndays}
            ></StockChartHV>
          ) : (
            <></>
          )}
          {chartType == CHART_TYPE.BAR_CHART ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                minHeight: 0,
              }}
            >
              <div style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
                <BarChart
                  id={props.id}
                  val={props.val}
                  stateData={stateData}
                  symbol={selectedInstrument}
                  nDays={userSettings.data.default_lc_ndays}
                  initialData={initialData}
                  toggleState={toggleState}
                  saveChartState={props.saveChartState}
                  isGlobalBookmark={props.isGlobalBookmark}
                  globalBookmarkData={props.globalBookmarkData}
                  setIsDirty={props.setIsDirty}
                  toggleRefresh={toggleRefresh}
                  openSubscribeModal={props.openSubscribeModal}
                  revertToPreviousChart={props.revertToPreviousChart}
                ></BarChart>
              </div>
              {selectedInstrumentData ? (
                <LineChartFooterNew
                  embedded
                  chartType={chartType}
                  chartStateData={props.chartStateData}
                  userSettings={userSettings}
                  selectedInstrumentData={selectedInstrumentData}
                  openStockChart={openStockChart}
                  selectedInstrument={selectedInstrument}
                  openLineChart={openLineChart}
                  basicUser={props.basicUser}
                  handleVPType={handleVPType}
                  handleFooterLoaded={handleFooterLoaded}
                  handleChartChange={handleChartChange}
                  auth={auth}
                  showPriceTable={showPriceTable}
                  showTable={showTable}
                  openSubscribeModal={showSubscribeModal}
                  openOFChart={openOFChart}
                  openMPChart={openMPChart}
                  openSettings={openSettings}
                  plot={barPlotType}
                  plotData={barPlotData}
                  isEliteUser={isEliteUser}
                  showTimeFrame={false}
                />
              ) : null}
            </div>
          ) : (
            <></>
          )}

          {chartType != CHART_TYPE.OF_CHART && chartType != CHART_TYPE.MARKET_PROFILE && chartType != CHART_TYPE.LINE_CHART && chartType != CHART_TYPE.BAR_CHART && selectedInstrumentData ? (
            <LineChartFooter
              chartType={chartType}
              chartStateData={props.chartStateData}
              userSettings={userSettings}
              selectedInstrumentData={selectedInstrumentData}
              openStockChart={openStockChart}
              selectedInstrument={selectedInstrument}
              openLineChart={openLineChart}
              basicUser={props.basicUser}
              handleVPType={handleVPType}
              handleFooterLoaded={handleFooterLoaded}
              handleChartChange={handleChartChange}
              auth={auth}
              showPriceTable={showPriceTable}
              showTable={showTable}
              openSubscribeModal={showSubscribeModal}
              openOFChart={openOFChart}
              openMPChart={openMPChart}
              openSettings={openSettings}
              isEliteUser={isEliteUser}
            />
          ) : (
            <></>
          )}
        </>
      )}
       {showSettings?
     <BarChartSettings open={true} cancelHandler={cancelSettings} saveHandler={saveSettings} ></BarChartSettings>    :
     <></>
    }
    {showDemoPopup?
      <OfDemoPopup open={true} demoIndex={demoIndex} demoType={showDemoState.demoType} hasOfferTr={showDemoState.hasOfferTr} onClose={()=>setShowDemoPopup(false)} onDemoStart={()=>setShowDemoConfirmPopup(true)}></OfDemoPopup>
      :
      <></>
    }
    {showDemoConfirmPopup?
      <DemoConfirmationPopup open={true} demoType={showDemoState.demoType} onClose={()=>setShowDemoConfirmPopup(false)} auth={auth}></DemoConfirmationPopup>
      :
      <></>
    }
    <AppErrorPopup
      open={open}
      message={msg}
      severity={severity}
      onClose={handleClose}
      showCloseX
    />
    </>
  )
}

export default BarChartContainer